export default {
  IMG_PREV: 'https://haigehome.oss-cn-hangzhou.aliyuncs.com/',
  IMG_UPLOAD_PATH: 'http://118.31.75.142:9121/OSS/upload',
  // 获取路径参数
  getQueryString (name) {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    let r = window.location.search.substr(1).match(reg)
    if (r != null) {
      return unescape(r[2])
    }
    return null
  },
  // 初始化图片尺寸
  initImgs (parmas) {
    let imgWidth = parmas.childNodes[0].clientWidth
    let imgHeight = parmas.childNodes[0].clientHeight
    // let rowWidth = parmas.clientWidth
    let rowHeight = parmas.clientHeight
    // if(imgWidth !== 0 && imgHeight !== 0) {
    if (imgWidth > imgHeight) {
      parmas.childNodes[0].style.height = `${rowHeight}px`
    } else if (imgWidth === imgHeight) {
      parmas.childNodes[0].style.height = `${rowHeight}px`
    } else {
      parmas.childNodes[0].style.width = `${rowHeight}px`
    }
    // }
  },
  // 判断是否为undefined
  isUndefined (value) {
    // 获得undefined，保证它没有被重新赋值
    return value === void (0)
  },
  /**
   * 和PHP一样的时间戳格式化函数
   * @param {string} format 格式
   * @param {int} timestamp 要格式化的时间 默认为当前时间
   * @return {string}   格式化的时间字符串
   */
  dateFormat (date, format) {
    if (!date) return ''
    if (/^\d+$/.test(date)) {
      date = Number(date)
    } else if (typeof date === 'string') {
      date = date.replace(/\.|-/g, '/')
    }
    format || (format = 'MM月dd日')
    let dateTime = new Date(date)
    let o = {
      'y+': dateTime.getFullYear(),
      'M+': dateTime.getMonth() + 1, // month
      'd+': dateTime.getDate(), // day
      'H+': dateTime.getHours(), // hour
      'm+': dateTime.getMinutes(), // minute
      's+': dateTime.getSeconds(), // second
      'q+': Math.floor((dateTime.getMonth() + 3) / 3), // quarter
      S: dateTime.getMilliseconds() // millisecond
    }
    if (/(y+)/.test(format)) {
      format = format.replace(
        RegExp.$1,
        (dateTime.getFullYear() + '').substr(4 - RegExp.$1.length)
      )
    }

    for (var k in o) {
      if (new RegExp('(' + k + ')').test(format)) {
        format = format.replace(
          RegExp.$1,
          RegExp.$1.length === 1
            ? o[k]
            : ('00' + o[k]).substr(('' + o[k]).length)
        )
      }
    }
    return format
  },
  // animate
  animate (target) {
    let count = 10
    let eq = setInterval(() => {
      if (document.body.scrollTop > target) {
        document.body.scrollTop -= count
        if (document.body.scrollTop <= target) {
          document.body.scrollTop = target - 50
          clearInterval(eq)
        }
      } else {
        document.body.scrollTop += count
        if (document.body.scrollTop >= target) {
          document.body.scrollTop = target - 30
          clearInterval(eq)
        }
      }
      count += 3
    }, 20)
  },
  /**
   * 用于把用utf16编码的字符转换成实体字符，以供后台存储
   * @param  {string} str 将要转换的字符串，其中含有utf16字符将被自动检出
   * @return {string}     转换后的字符串，utf16字符将被转换成&#xxxx形式的实体字符
   */
  utf16toEntities (str) {
    var patt = /[\ud800-\udbff][\udc00-\udfff]/g // 检测utf16字符正则
    str = str.replace(patt, function (char) {
      var H, L, code
      if (char.length === 2) {
        H = char.charCodeAt(0) // 取出高位
        L = char.charCodeAt(1) // 取出低位
        code = (H - 0xD800) * 0x400 + 0x10000 + L - 0xDC00 // 转换算法
        return '&#' + code + ''
      } else {
        return char
      }
    })
    return str
  },
  entitiestoUtf16 (str) {
    // 检测出形如&#12345形式的字符串
    if (!str) return
    var strObj = this.utf16toEntities(str)
    var patt = /&#\d+/g
    var H, L, code, temp
    var arr = strObj.match(patt) || []
    for (var i = 0; i < arr.length; i++) {
      code = arr[i]
      temp = code.replace('&#', '').replace('', '')
      // 高位
      H = Math.floor((temp - 0x10000) / 0x400) + 0xD800
      // 低位
      L = (temp - 0x10000) % 0x400 + 0xDC00
      var s = String.fromCharCode(H, L)
      strObj = strObj.replace(code, s)
    }
    return strObj
  },
  /**
   * 使用循环的方式判断一个元素是否存在于一个数组中
   * @param {Object} arr 数组
   * @param {Object} value 元素值
   */
  isInArray (arr, value) {
    for (let i = 0; i < arr.length; i++) {
      if (value === arr[i]) {
        return true
      }
    }
    return false
  },
  toFixedNum (num) {
    let val = 0
    if (!this.isNumber(num)) {
      val = 0
    }
    val = num
    var nStr = (val * 1).toFixed(2)
    nStr += ''
    let x = nStr.split('.')
    let x1 = x[0]
    let x2 = x.length > 1 ? '.' + x[1] : ''
    var rgx = /(\d+)(\d{3})/
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + ',' + '$2')
    }
    return x1 + x2
  },
  /**
   * 使用循环的方式判断一个对象是否为空
   * @param {Object} obj 数组
   */
  isEmptyObject (obj) {
    for (var key in obj) {
      return false
    }
    return true
  },
  /**
   * 手机号
   */
  isPhoneNumber (str) {
    const reg = /^1[3456789]\d{9}$/
    return reg.test(str)
  },
  isNumber (num) {
    let reg = /^(([0-9]+\.[0-9]*[0-9][0-9]*)|([0-9]*[0-9][0-9]*\.[0-9]+)|([0-9]*[0-9][0-9]*))$/
    return reg.test(num)
  },
  /**
   * str->json
   */
  evil (fn) {
    let Fn = Function
    return new Fn('return ' + fn)()
  },
  formatDateMonth (date) {
    if (!date) return ''
    let newDate = new Date(date)
    let year = newDate.getFullYear()
    let month = newDate.getMonth() + 1
    if (month < 10) month = `0${month}`
    return `${year}-${month}`
  },
  formatDate (date) {
    if (!date) return ''
    let newDate = new Date(date)
    let year = newDate.getFullYear()
    let month = newDate.getMonth() + 1
    let day = newDate.getDate()
    if (month < 10) month = `0${month}`
    if (day < 10) day = `0${day}`
    return `${year}-${month}-${day}`
  },
  formatDate2 (date) {
    if (!date) return ''
    let newDate = new Date(date)
    let year = newDate.getFullYear()
    let month = newDate.getMonth() + 1
    let day = newDate.getDate()
    if (month < 10) month = `0${month}`
    if (day < 10) day = `0${day}`
    return `${year}.${month}.${day}`
  },
  formatDateStr (date) {
    if (!date) return ''
    let newDate = new Date(date)
    let year = newDate.getFullYear()
    let month = newDate.getMonth() + 1
    let day = newDate.getDate()
    if (month < 10) month = `0${month}`
    if (day < 10) day = `0${day}`
    return `${year}年${month}月${day}日`
  },
  formatTime (date) {
    if (!date) return ''
    let newDate = new Date(date)
    let year = newDate.getFullYear()
    let month = newDate.getMonth() + 1
    let day = newDate.getDate()
    let hours = newDate.getHours()
    let minutes = newDate.getMinutes()
    if (month < 10) month = `0${month}`
    if (day < 10) day = `0${day}`
    if (hours < 10) hours = `0${hours}`
    if (minutes < 10) minutes = `0${minutes}`
    return `${year}-${month}-${day} ${hours}:${minutes}`
  },
  formatTime2 (date) {
    if (!date) return ''
    let newDate = new Date(date)
    let year = newDate.getFullYear()
    let month = newDate.getMonth() + 1
    let day = newDate.getDate()
    let hours = newDate.getHours()
    let minutes = newDate.getMinutes()
    if (month < 10) month = `0${month}`
    if (day < 10) day = `0${day}`
    if (hours < 10) hours = `0${hours}`
    if (minutes < 10) minutes = `0${minutes}`
    return `${year}.${month}.${day} ${hours}:${minutes}`
  },
  deepClone (source) {
    if (!source && typeof source !== 'object') {
      throw new Error('error arguments', 'shallowClone')
    }
    const targetObj = source.constructor === Array ? [] : {}
    Object.keys(source).forEach((keys) => {
      if (source[keys] && typeof source[keys] === 'object') {
        targetObj[keys] = this.deepClone(source[keys])
      } else {
        targetObj[keys] = source[keys]
      }
    })
    return targetObj
  },
  updateList (list, type, data) {
    if (type === 0) {
      // 新增
      if (!data.parentId) {
        list.push(data)
      } else {
        for (let i = 0; i < list.length; i++) {
          if (list[i].id === data.parentId) {
            if (!list[i].children) {
              list[i].children = []
            }
            list[i].children.push(data)
            return true
          } else {
            if (list[i].children && list[i].children.length > 0) {
              if (this.updateList(list[i].children, type, data)) {
                return true
              }
            }
          }
        }
      }
    } else if (type === 1) {
    //  修改
      for (let i = 0; i < list.length; i++) {
        if (list[i].id === data.id) {
          let newValue = {
            ...list[i],
            ...data
          }
          list.splice(i, 1, newValue)
          return true
        } else {
          if (list[i].children && list[i].children.length > 0) {
            if (this.updateList(list[i].children, type, data)) {
              return true
            }
          }
        }
      }
    } else if (type === 2) {
    //  删除
      for (let i = 0; i < list.length; i++) {
        if (list[i].id === data.id) {
          list.splice(i, 1)
          return true
        } else {
          if (list[i].children && list[i].children.length > 0) {
            if (this.updateList(list[i].children, type, data)) {
              return true
            }
          }
        }
      }
    }
    return false
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js